














import Vue from 'vue';
import ProuniStepLayout from '@/components/prouni/ProuniStepLayout.vue';
import ProuniAcceptanceForm from '@/components/forms/prouni/ProuniAcceptanceForm.vue';
import prouniSteps from '@/pipeline/prouni/steps';
import PROUNI_VIEWS_NAMES from '@/router/prouniViewsNames';
import { ProuniApplication } from '@/store/modules/prouni/types';

export default Vue.extend({
  name: 'ProuniAcceptanceView',
  components: { ProuniStepLayout, ProuniAcceptanceForm },
  data() {
    return {
      form: {} as Partial<ProuniApplication>,
      isValid: false,
      isLoading: false,
      error: false,
    };
  },
  computed: {
    application(): ProuniApplication | null {
      return this.$store.getters.prouniApplication;
    },
  },
  methods: {
    inputHandler(form: Partial<ProuniApplication>, isValid: boolean) {
      this.form = form;
      this.isValid = isValid;
      this.error = false;
    },
    async finishHandler() {
      this.isLoading = true;
      this.error = false;
      try {
        await this.$store.dispatch('UPSERT_PROUNI_APPLICATION', {
          ...this.form,
          pipelineState: { step: prouniSteps.acceptance },
        });
        await this.$store.dispatch('SUBMIT_PROUNI_APPLICATION');
        this.$router.push({ name: PROUNI_VIEWS_NAMES.PROUNI_FOLLOW_UP }).catch(() => undefined);
      } catch (err) {
        this.error = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
